(function () {
  var FILTERED_OUT_CLASS = 'is-ev-filtered-out';
  var MONTH_PARAM = 'events_month';
  var PAGE_PARAM = 'events_page';
  var DEFAULT_PAGE_SIZE = 9;
  var ALL_MONTHS_VALUE = 'all';
  var MONTH_SHORT_LABELS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function parseMonthKey(key) {
    var parts = (key || '').split('-');
    if (parts.length !== 2) return null;
    var year = Number(parts[0]);
    var month = Number(parts[1]);
    if (!Number.isInteger(year) || !Number.isInteger(month)) return null;
    if (month < 1 || month > 12) return null;
    return { year: year, month: month };
  }

  function formatMonthLabel(year, month) {
    var date = new Date(year, month - 1, 1);
    try {
      return new Intl.DateTimeFormat(document.documentElement.lang || 'en', {
        month: 'long',
        year: 'numeric',
      }).format(date);
    } catch (err) {
      return date.toLocaleDateString('en', { month: 'long', year: 'numeric' });
    }
  }

  function generateMonthRange(minKey, maxKey) {
    var min = parseMonthKey(minKey);
    var max = parseMonthKey(maxKey);
    if (!min || !max) return [];

    var months = [];
    var y = min.year;
    var m = min.month;

    while (y < max.year || (y === max.year && m <= max.month)) {
      var key = String(y) + '-' + String(m).padStart(2, '0');
      months.push({ key: key, label: formatMonthLabel(y, m) });
      m += 1;
      if (m === 13) {
        m = 1;
        y += 1;
      }
    }

    return months;
  }

  function getContinuousMonthKeysFromCards(cards) {
    if (!cards || !cards.length) return [];

    var existingKeys = [];
    cards.forEach(function (card) {
      var key = (card.getAttribute('data-month') || '').trim();
      if (!key || existingKeys.indexOf(key) !== -1) return;
      existingKeys.push(key);
    });

    if (!existingKeys.length) return [];

    existingKeys.sort();
    var months = generateMonthRange(existingKeys[0], existingKeys[existingKeys.length - 1]);
    return months.map(function (monthItem) {
      return monthItem.key;
    });
  }

  function getEventMonthKeysFromCards(cards) {
    if (!cards || !cards.length) return [];

    var keys = [];
    cards.forEach(function (card) {
      var key = (card.getAttribute('data-month') || '').trim();
      if (!parseMonthKey(key)) return;
      if (keys.indexOf(key) !== -1) return;
      keys.push(key);
    });

    keys.sort();
    return keys;
  }

  function buildMonthRange(control, cards) {
    var keys = getContinuousMonthKeysFromCards(cards);
    if (keys.length && control) {
      control.min = keys[0];
      control.max = keys[keys.length - 1];
    }
    return keys;
  }

  function getCurrentMonthKey() {
    var now = new Date();
    return String(now.getFullYear()) + '-' + String(now.getMonth() + 1).padStart(2, '0');
  }

  function setDefaultMonth(control, sortedKeys) {
    if (!control || !sortedKeys.length) return;

    var currentKey = getCurrentMonthKey();

    if (sortedKeys.indexOf(currentKey) !== -1) {
      control.value = currentKey;
    } else {
      control.value = sortedKeys[0];
    }
  }

  function isUrlMonthParamValid(raw) {
    var v = (raw || '').trim();
    if (!v) return false;
    return parseMonthKey(v) !== null;
  }

  function resolveMonthFromUrlOrDefault(control, sortedKeys, urlMonth) {
    if (!control || !sortedKeys.length) return;

    var raw = (urlMonth || '').trim().toLowerCase();
    if (raw === ALL_MONTHS_VALUE) {
      control.value = '';
      return;
    }

    if (isUrlMonthParamValid(urlMonth)) {
      control.value = urlMonth.trim();
      return;
    }

    setDefaultMonth(control, sortedKeys);
  }

  function monthKeyForUrl(control) {
    var v = control ? (control.value || '').trim() : '';
    if (!v) return ALL_MONTHS_VALUE;
    if (parseMonthKey(v)) return v;
    return ALL_MONTHS_VALUE;
  }

  function getDisplayLabelForMonthKey(key) {
    var parsed = parseMonthKey(key);
    if (!parsed) return '';
    return formatMonthLabel(parsed.year, parsed.month);
  }

  function updateMonthDisplay(root, control) {
    if (!root || !control) return;
    var display = root.querySelector('[data-events-month-display]');
    if (!display) return;

    var value = (control.value || '').trim();
    if (!value) {
      display.textContent = 'All';
      return;
    }

    display.textContent = getDisplayLabelForMonthKey(value) || 'All';
  }

  function buildMonthPickerState(sortedKeys) {
    var years = [];
    var keysSet = {};

    (sortedKeys || []).forEach(function (key) {
      keysSet[key] = true;
      var parsed = parseMonthKey(key);
      if (!parsed) return;
      if (years.indexOf(parsed.year) === -1) years.push(parsed.year);
    });

    years.sort(function (a, b) {
      return a - b;
    });

    return {
      keysSet: keysSet,
      years: years,
    };
  }

  function renderMonthPicker(root, control, state, year) {
    if (!root || !control || !state) return;
    var yearLabel = root.querySelector('[data-events-year-label]');
    var grid = root.querySelector('[data-events-month-grid]');
    var prev = root.querySelector('[data-events-year-prev]');
    var next = root.querySelector('[data-events-year-next]');
    if (!yearLabel || !grid) return;

    yearLabel.textContent = String(year);
    grid.innerHTML = '';

    var selected = (control.value || '').trim();
    for (var i = 0; i < 12; i += 1) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ev-month-picker__month';
      btn.textContent = MONTH_SHORT_LABELS[i];

      var month = i + 1;
      var key = String(year) + '-' + String(month).padStart(2, '0');
      btn.dataset.monthKey = key;
      var enabled = !!state.keysSet[key];
      btn.disabled = !enabled;
      if (enabled && selected === key) btn.classList.add('is-active');
      grid.appendChild(btn);
    }

    if (prev) {
      prev.disabled = state.years.length ? year <= state.years[0] : true;
      prev.setAttribute('aria-disabled', prev.disabled ? 'true' : 'false');
    }
    if (next) {
      next.disabled = state.years.length ? year >= state.years[state.years.length - 1] : true;
      next.setAttribute('aria-disabled', next.disabled ? 'true' : 'false');
    }
  }

  function initCustomMonthPicker(root, control, sortedKeys, cards) {
    if (!root || !control || root.dataset.eventsPickerBound === 'true') return;
    var display = root.querySelector('[data-events-month-display]');
    var picker = root.querySelector('[data-events-month-picker]');
    var yearLabel = root.querySelector('[data-events-year-label]');
    var prev = root.querySelector('[data-events-year-prev]');
    var next = root.querySelector('[data-events-year-next]');
    var clearBtn = root.querySelector('[data-events-month-clear]');
    var currentBtn = root.querySelector('[data-events-month-current]');
    var grid = root.querySelector('[data-events-month-grid]');
    if (!display || !picker || !yearLabel || !prev || !next || !clearBtn || !currentBtn || !grid) return;

    var state = buildMonthPickerState(getEventMonthKeysFromCards(cards));
    var currentYear = state.years.length ? state.years[0] : new Date().getFullYear();
    var selectedParsed = parseMonthKey((control.value || '').trim());
    if (selectedParsed && state.years.indexOf(selectedParsed.year) !== -1) {
      currentYear = selectedParsed.year;
    }

    function closePicker() {
      picker.hidden = true;
      display.setAttribute('aria-expanded', 'false');
    }

    function openPicker() {
      var selectedNow = parseMonthKey((control.value || '').trim());
      if (selectedNow && state.years.indexOf(selectedNow.year) !== -1) {
        currentYear = selectedNow.year;
      }
      renderMonthPicker(root, control, state, currentYear);
      picker.hidden = false;
      display.setAttribute('aria-expanded', 'true');
    }

    display.addEventListener('click', function () {
      if (picker.hidden) {
        openPicker();
      } else {
        closePicker();
      }
    });

    prev.addEventListener('click', function () {
      if (prev.disabled) return;
      if (!state.years.length) return;
      currentYear = Math.max(state.years[0], currentYear - 1);
      renderMonthPicker(root, control, state, currentYear);
    });

    next.addEventListener('click', function () {
      if (next.disabled) return;
      if (!state.years.length) return;
      currentYear = Math.min(state.years[state.years.length - 1], currentYear + 1);
      renderMonthPicker(root, control, state, currentYear);
    });

    clearBtn.addEventListener('click', function () {
      control.value = '';
      control.dispatchEvent(new Event('change', { bubbles: true }));
      closePicker();
    });

    currentBtn.addEventListener('click', function () {
      var currentKey = getCurrentMonthKey();
      if (state.keysSet[currentKey]) {
        control.value = currentKey;
      } else {
        setDefaultMonth(control, sortedKeys);
      }
      control.dispatchEvent(new Event('change', { bubbles: true }));
      closePicker();
    });

    grid.addEventListener('click', function (ev) {
      var t = ev.target;
      if (!t || !t.matches || !t.matches('.ev-month-picker__month[data-month-key]')) return;
      if (t.disabled) return;
      control.value = t.dataset.monthKey || '';
      control.dispatchEvent(new Event('change', { bubbles: true }));
      closePicker();
    });

    document.addEventListener('click', function (ev) {
      if (!root.contains(ev.target)) closePicker();
    });

    control.addEventListener('change', function () {
      updateMonthDisplay(root, control);
      if (!picker.hidden) renderMonthPicker(root, control, state, currentYear);
    });

    updateMonthDisplay(root, control);
    root.dataset.eventsPickerBound = 'true';
  }

  function applyMonthFilter(control, cards, emptyState) {
    if (!cards.length) return;

    if (!control) {
      var visibleWithoutFilter = 0;
      cards.forEach(function (card) {
        card.classList.remove(FILTERED_OUT_CLASS);
        card.removeAttribute('hidden');
        visibleWithoutFilter += 1;
      });
      if (emptyState) emptyState.hidden = visibleWithoutFilter > 0;
      return;
    }

    var value = (control.value || '').trim();
    var visibleCount = 0;

    cards.forEach(function (card) {
      if (card.hasAttribute('data-always-visible')) {
        card.classList.remove(FILTERED_OUT_CLASS);
        card.removeAttribute('hidden');
        visibleCount += 1;
        return;
      }

      var month = (card.getAttribute('data-month') || '').trim();
      var hide = month !== value;

      card.classList.toggle(FILTERED_OUT_CLASS, hide);
      if (hide) {
        card.setAttribute('hidden', 'hidden');
      } else {
        card.removeAttribute('hidden');
        visibleCount += 1;
      }
    });

    if (emptyState) {
      emptyState.hidden = visibleCount > 0;
    }
  }

  function getUrlMonth() {
    var params = new URLSearchParams(window.location.search);
    return (params.get(MONTH_PARAM) || '').trim();
  }

  function getUrlPage() {
    var params = new URLSearchParams(window.location.search);
    var rawPage = Number(params.get(PAGE_PARAM));
    if (!Number.isInteger(rawPage) || rawPage < 1) return 1;
    return rawPage;
  }

  function syncUrlParams(monthValue, pageValue) {
    var params = new URLSearchParams(window.location.search);
    if (monthValue === ALL_MONTHS_VALUE) {
      params.set(MONTH_PARAM, ALL_MONTHS_VALUE);
    } else if (parseMonthKey(monthValue || '')) {
      params.set(MONTH_PARAM, monthValue);
    } else {
      params.set(MONTH_PARAM, ALL_MONTHS_VALUE);
    }

    if (pageValue && pageValue > 1) {
      params.set(PAGE_PARAM, String(pageValue));
    } else {
      params.delete(PAGE_PARAM);
    }

    var query = params.toString();
    var nextUrl = window.location.pathname + (query ? '?' + query : '') + window.location.hash;
    window.history.replaceState({}, '', nextUrl);
  }

  function renderPagination(nav, totalPages, currentPage) {
    if (!nav) return;

    if (totalPages <= 1) {
      nav.hidden = true;
      nav.innerHTML = '';
      return;
    }

    nav.hidden = false;
    nav.innerHTML = '';

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'ev-pagination__btn';
    prev.textContent = 'Prev';
    prev.dataset.page = String(currentPage - 1);
    prev.disabled = currentPage === 1;
    nav.appendChild(prev);

    for (var p = 1; p <= totalPages; p += 1) {
      var pageBtn = document.createElement('button');
      pageBtn.type = 'button';
      pageBtn.className = 'ev-pagination__btn' + (p === currentPage ? ' is-active' : '');
      pageBtn.textContent = String(p);
      pageBtn.dataset.page = String(p);
      nav.appendChild(pageBtn);
    }

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'ev-pagination__btn';
    next.textContent = 'Next';
    next.dataset.page = String(currentPage + 1);
    next.disabled = currentPage === totalPages;
    nav.appendChild(next);
  }

  function getPageSize(root) {
    if (!root) return DEFAULT_PAGE_SIZE;
    var raw = Number(root.getAttribute('data-events-page-size'));
    if (!Number.isInteger(raw) || raw < 1) return DEFAULT_PAGE_SIZE;
    return raw;
  }

  function applyFilterAndPagination(root, control, cards, emptyState, paginationNav, requestedPage) {
    var selectedMonth = control ? (control.value || '').trim() : '';
    var pageSize = getPageSize(root);
    var matchingCards = [];

    cards.forEach(function (card) {
      var month = (card.getAttribute('data-month') || '').trim();
      var showByMonth = !selectedMonth || month === selectedMonth || card.hasAttribute('data-always-visible');
      if (showByMonth) matchingCards.push(card);
    });

    var totalPages = Math.max(1, Math.ceil(matchingCards.length / pageSize));
    var currentPage = Math.max(1, Math.min(requestedPage || 1, totalPages));
    var start = (currentPage - 1) * pageSize;
    var end = start + pageSize;

    cards.forEach(function (card) {
      card.classList.add(FILTERED_OUT_CLASS);
      card.setAttribute('hidden', 'hidden');
    });

    matchingCards.forEach(function (card, index) {
      var showInPage = index >= start && index < end;
      card.classList.toggle(FILTERED_OUT_CLASS, !showInPage);
      if (showInPage) {
        card.removeAttribute('hidden');
      } else {
        card.setAttribute('hidden', 'hidden');
      }
    });

    if (emptyState) {
      emptyState.hidden = matchingCards.length > 0;
    }

    renderPagination(paginationNav, matchingCards.length === 0 ? 0 : totalPages, currentPage);
    root.dataset.eventsCurrentPage = String(currentPage);

    var urlMonth = monthKeyForUrl(control);
    syncUrlParams(urlMonth, matchingCards.length === 0 ? 1 : currentPage);
    updateMonthDisplay(root, control);
  }

  function initEventsMonthFilter(root) {
    if (!root) return;

    var grid = root.querySelector('[data-events-active-grid]');
    var control = root.querySelector('[data-events-month-input]');
    var emptyState = root.querySelector('[data-events-empty-filter]');
    var paginationNav = root.querySelector('[data-events-pagination]');
    var cards = grid ? grid.querySelectorAll('[data-events-active-card]') : [];

    if (!control) {
      cards.forEach(function (card) {
        card.classList.remove(FILTERED_OUT_CLASS);
        card.removeAttribute('hidden');
      });
      if (emptyState) emptyState.hidden = true;
      return;
    }

    if (root.dataset.eventsFilterBound === 'true') {
      return;
    }

    var sortedKeys = buildMonthRange(control, cards);
    if (!sortedKeys.length) {
      root.dataset.eventsFilterBound = 'true';
      if (emptyState) emptyState.hidden = false;
      if (paginationNav) paginationNav.hidden = true;
      return;
    }

    var monthFromUrl = getUrlMonth();
    resolveMonthFromUrlOrDefault(control, sortedKeys, monthFromUrl);
    initCustomMonthPicker(root, control, sortedKeys, cards);

    applyFilterAndPagination(root, control, cards, emptyState, paginationNav, getUrlPage());

    root.addEventListener('change', function onEventsMonthChange(ev) {
      var t = ev.target;
      if (!t || !t.matches || !t.matches('[data-events-month-input]')) return;
      if (!root.contains(t)) return;

      var g = root.querySelector('[data-events-active-grid]');
      var c = g ? g.querySelectorAll('[data-events-active-card]') : [];
      var e = root.querySelector('[data-events-empty-filter]');
      var p = root.querySelector('[data-events-pagination]');
      applyFilterAndPagination(root, t, c, e, p, 1);
    });

    root.addEventListener('click', function onEventsPaginationClick(ev) {
      var target = ev.target;
      if (!target || !target.matches || !target.matches('.ev-pagination__btn[data-page]')) return;
      if (!root.contains(target)) return;

      var page = Number(target.dataset.page);
      if (!Number.isInteger(page) || page < 1) return;

      var g = root.querySelector('[data-events-active-grid]');
      var c = g ? g.querySelectorAll('[data-events-active-card]') : [];
      var e = root.querySelector('[data-events-empty-filter]');
      var p = root.querySelector('[data-events-pagination]');
      applyFilterAndPagination(root, control, c, e, p, page);
    });

    root.dataset.eventsFilterBound = 'true';
  }

  function initAll() {
    document.querySelectorAll('[data-section-events]').forEach(function (root) {
      initEventsMonthFilter(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target;
    if (!target) return;

    var root = target.matches && target.matches('[data-section-events]')
      ? target
      : target.querySelector && target.querySelector('[data-section-events]');

    if (root) {
      delete root.dataset.eventsFilterBound;
      delete root.dataset.eventsPickerBound;
      initEventsMonthFilter(root);
    }
  });
})();
